import { createRouter } from '@tanstack/react-router';

import { type RouterContext } from '@/lib/router-context';
import { routeTree } from '@/routeTree.gen';

import { type ProjectItem, type User } from './types';

export const router = createRouter({
  routeTree,
  // Prefetch a route's split chunk on link hover/focus so code-splitting
  // doesn't add navigation latency on first visit to each route.
  defaultPreload: 'intent',
  context: {
    // AppRouter supplies the provider client before any routes load.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- router context injection placeholder
    queryClient: undefined!,
    auth: {
      isAuthenticated: false,
      isLoading: true,
      isManager: false,
      canViewUsers: false,
      canManageOrgs: false,
    } satisfies RouterContext['auth'],
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    projectItem?: ProjectItem;
    user?: User;
    from?: string;
  }
}
